export default "__VITE_ASSET__BL0ImPjK__"